import { render, staticRenderFns } from "./OfficeBuilding.vue?vue&type=template&id=422c53fc"
import script from "./OfficeBuilding.vue?vue&type=script&lang=js"
export * from "./OfficeBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports